import React, { useEffect, createElement } from 'react';
import { HeroSection } from './components/HeroSection';
import { PainPointsSection } from './components/PainPointsSection';
import { FacebookComments, CommentData } from './components/FacebookComments';
import { SpiritualSection } from './components/SpiritualSection';
import { SymptomsSection } from './components/SymptomsSection';
import { ServicesSection } from './components/ServicesSection';
import { CTASection } from './components/CTASection';
import { LegalFooter } from './components/LegalFooter';
const group1Comments: CommentData[] = [{
  name: 'María González',
  text: 'No lo podía creer... mi esposo volvió a casa después de 3 meses. Gracias al Maestro por su trabajo. 🙏',
  likes: 47,
  timeAgo: '2 días'
}, {
  name: 'Carlos Ramírez',
  text: 'Mi novia se había ido con otro y yo estaba destrozado. Después del trabajo espiritual, ella misma me buscó. Increíble.',
  likes: 32,
  timeAgo: '5 días'
}, {
  name: 'Ana Lucía Pérez',
  text: 'Llevaba 6 meses sin hablar con mi pareja. A las 2 semanas del ritual, me escribió como si nada hubiera pasado. ❤️',
  likes: 58,
  timeAgo: '1 semana'
}, {
  name: 'Roberto Mendoza',
  text: 'Yo era escéptico, pero mi esposa cambió completamente. Volvió el amor, la comunicación, todo. Muy agradecido.',
  likes: 41,
  timeAgo: '3 días'
}, {
  name: 'Patricia Flores',
  text: 'Mi caso parecía imposible. 2 años separados. Hoy estamos juntos de nuevo y más fuertes que nunca. 💕',
  likes: 63,
  timeAgo: '4 días'
}, {
  name: 'Diego Hernández',
  text: 'El Maestro es una persona seria y profesional. Mi pareja regresó y nuestra relación mejoró muchísimo.',
  likes: 29,
  timeAgo: '1 semana'
}, {
  name: 'Valentina Torres',
  text: 'Gracias, gracias, gracias. No tengo palabras. Mi familia está unida de nuevo. 🙏❤️',
  likes: 55,
  timeAgo: '2 días'
}, {
  name: 'Fernando Castro',
  text: 'Después de tanto sufrimiento, por fin tengo paz. Mi esposa volvió y estamos reconstruyendo nuestro hogar.',
  likes: 37,
  timeAgo: '6 días'
}];
export function App() {
  useEffect(() => {
    // SmartTarget WhatsApp button
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = 'https://smartarget.online/loader.js?u=d4b17f89128d601376cfa61bc95e1f7ce48138a5';
    script.async = true;
    document.body.appendChild(script);
    // Tawk.to Live Chat
    const tawkScript = document.createElement('script');
    tawkScript.type = 'text/javascript';
    tawkScript.async = true;
    tawkScript.src = 'https://embed.tawk.to/661c6dd91ec1082f04e23daa/1hrfgq6lh';
    tawkScript.charset = 'UTF-8';
    tawkScript.setAttribute('crossorigin', '*');
    document.head.appendChild(tawkScript);
    return () => {
      document.body.removeChild(script);
      document.head.removeChild(tawkScript);
    };
  }, []);
  return <main className="min-h-screen w-full bg-[#f5f5f7] font-sans text-[#1f2933]" data-id="element-0">
      <HeroSection data-id="element-1" />
      <PainPointsSection data-id="element-2" />
      <SpiritualSection data-id="element-3" />
      <SymptomsSection data-id="element-4" />
      <FacebookComments comments={group1Comments} data-id="element-5" />
      <ServicesSection data-id="element-6" />
      <CTASection data-id="element-7" />
      <LegalFooter data-id="element-8" />
    </main>;
}